import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { RtUICoreOverlayModule } from '../core/overlay/overlay.module';
import { InputWithSelectDropdownComponent } from './input-with-select-dropdown/input-with-select-dropdown.component';
import { InputWithSelectComponent } from './input-with-select.component';

@NgModule({
  imports: [
    CommonModule,
    RtUICoreOverlayModule,
    ReactiveFormsModule,
    InputWithSelectComponent,
    InputWithSelectDropdownComponent,
  ],
  exports: [InputWithSelectComponent, InputWithSelectDropdownComponent],
})
export class RtInputWithSelectModule {}
export {
  InputSelectDropdownOption,
  InputWithSelectDropdownComponent,
} from './input-with-select-dropdown/input-with-select-dropdown.component';
export { InputWithSelectComponent } from './input-with-select.component';
